import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

import { exportarCsv } from '@/ui/exportCsv';
import { COR_PRIMARIA_PDF } from '@/nucleo/pdf/cores';

export interface ExportacaoFiscalPayload {
  titulo: string;
  competencia: string;
  cabecalhos: string[];
  linhas: string[][];
  nomeBase: string;
}

export function exportarRelatorioFiscalCsv(payload: ExportacaoFiscalPayload): void {
  exportarCsv(`${payload.nomeBase}.csv`, payload.cabecalhos, payload.linhas);
}

export function exportarRelatorioFiscalXlsx(payload: ExportacaoFiscalPayload): void {
  const planilha = XLSX.utils.aoa_to_sheet([payload.cabecalhos, ...payload.linhas]);
  const livro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(livro, planilha, payload.titulo.slice(0, 31));
  XLSX.writeFile(livro, `${payload.nomeBase}.xlsx`);
}

export function exportarRelatorioFiscalPdf(payload: ExportacaoFiscalPayload): void {
  const documento = new jsPDF({ orientation: 'landscape' });
  documento.setFontSize(14);
  documento.text(payload.titulo, 14, 16);
  documento.setFontSize(10);
  documento.text(`Competência: ${payload.competencia}`, 14, 24);
  documento.text(`Emitido em: ${new Date().toLocaleString('pt-BR')}`, 14, 30);

  autoTable(documento, {
    startY: 36,
    head: [payload.cabecalhos],
    body: payload.linhas,
    styles: { fontSize: 8 },
    headStyles: { fillColor: COR_PRIMARIA_PDF },
  });

  documento.save(`${payload.nomeBase}.pdf`);
}
